import Slider from 'react-slick';
import { Photo } from 'types/property';
import { PropertyPictureSliderProps } from './types';
import PropertyCarouselDataDisplay from '../PropertyCarouselDataDisplay/PropertyCarouselDataDisplay';
import './styles.scss';
import { Link } from 'react-router-dom';
import { LazyLoadImage } from 'react-lazy-load-image-component';

function PropertyPictureSlider(props: PropertyPictureSliderProps) {
  const { property, ownKey } = props;

  return (
    <div className="property-picture-slider">
      {/* <div className="position-relative"> // temporary removed from MVP
        <label className="position-absolute __heart-icon-wrapper d-block">
          <input type="checkbox" className="d-none" />
          <Heart />
        </label> */}
      <Slider infinite>
        {property.photos.map((photo: Photo, picKey: number) => (
          <Link to={`/details/${property.uid}`} key={`${property.uid}-${photo.url}-${picKey}-link`}>
            <LazyLoadImage
              src={photo.url}
              className="property-slider-fix-height"
              alt={`gallery ${picKey}`}
              visibleByDefault={picKey === 0}
              key={`${property.uid}-${photo.url}-${picKey}`}
            />
          </Link>
        ))}
      </Slider>
      {/* </div> */}
      <PropertyCarouselDataDisplay
        currencySymbol={property.currencySymbol}
        baseDailyRate={property.baseDailyRate}
        city={property.city}
        name={property.name}
        state={property.state}
      />
    </div>
  );
}
export default PropertyPictureSlider;
